import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=ee7febb4&scoped=true"
import script from "./NewTag.vue?vue&type=script&lang=js"
export * from "./NewTag.vue?vue&type=script&lang=js"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=ee7febb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7febb4",
  null
  
)

export default component.exports